import { MonoTypeOperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function isTruthy<T>(): MonoTypeOperatorFunction<T> {
  return filter<T>(item => !!item);
}
